const CODE_EXPIRY_DURATION = 1; // In year
const GIFT_A_PREMIUM_API_URL = 'https://us-central1-muslim-pro-app.cloudfunctions.net/MPWebAPIGiftAPremiumV2/';

export {
  CODE_EXPIRY_DURATION,
  GIFT_A_PREMIUM_API_URL,
};